/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetAllGroups,
    GetFactoriesByGroupID,
    GetVCCFactoriesByGroupID,
    GetFDCVehicleUtilizationReportDetails,
};

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetFDCVehicleUtilizationReportDetails(model) {
    const response = await CommonPost('/api/FDCVehicleUtilizationReport/GetFDCVehicleUtilizationReportDetails', null, model);
    return response.data;
    
}